import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Beaker } from "lucide-react";

interface FormulationTableProps {
  originalIngredients: string;
  replacementIngredients: string;
  functionalImprovements: string;
  nutritionalImprovements: {
    protein: string;
    sugars?: string;
    sodium?: string;
    vitamins?: string;
  };
}

export default function FormulationTable({
  originalIngredients,
  replacementIngredients,
  functionalImprovements,
  nutritionalImprovements,
}: FormulationTableProps) {
  return (
    <Card className="shadow-lg border border-slate-200 rounded-xl overflow-hidden">
      <CardHeader className="pb-3 pt-5 px-6">
        <CardTitle className="text-2xl font-semibold text-slate-800 flex items-center gap-2">
          <Beaker size={20} className="text-indigo-600" />
          Formulation
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow className="border-b border-slate-300 bg-slate-100">
              <TableHead className="h-12 px-4 align-middle text-lg font-semibold text-slate-500">Original Ingredients</TableHead>
              <TableHead className="h-12 px-4 align-middle text-lg font-semibold text-slate-500">
                Ingredients Replacement
              </TableHead>
              <TableHead className="h-12 px-4 align-middle text-lg font-semibold text-slate-500">Functional Improv.</TableHead>
              <TableHead className="h-12 px-4 align-middle text-lg font-semibold text-slate-500">Nutritional Improv.</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow className="border-t border-slate-200 hover:bg-slate-50 transition-colors">
              <TableCell className="p-4 align-top text-base text-slate-600">{originalIngredients}</TableCell>
              <TableCell className="p-4 align-top text-base text-slate-600">
                {replacementIngredients}
              </TableCell>
              <TableCell className="p-4 align-top text-base text-slate-600">
                {functionalImprovements}
              </TableCell>
              <TableCell className="p-4 align-top text-base text-slate-600">
                <div className="space-y-1">
                  <div>
                    <span className="font-semibold text-slate-700">Protein:</span>{" "}
                    <span className="text-base">{nutritionalImprovements.protein}</span>
                  </div>
                  {nutritionalImprovements.sugars && (
                    <div>
                      <span className="font-semibold text-slate-700">Sugars:</span>{" "}
                      <span className="text-base">{nutritionalImprovements.sugars}</span>
                    </div>
                  )}
                  {nutritionalImprovements.sodium && (
                    <div>
                      <span className="font-semibold text-slate-700">Sodium:</span>{" "}
                      <span className="text-base">{nutritionalImprovements.sodium}</span>
                    </div>
                  )}
                  {nutritionalImprovements.vitamins && (
                    <div>
                      <span className="font-semibold text-slate-700">Vitamins:</span>{" "}
                      <span className="text-base">{nutritionalImprovements.vitamins}</span>
                    </div>
                  )}
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
